import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import "./aos/aos.js";
import 'slick-carousel';
import AOS from 'aos';
import Header from './libs/header';
import './libs/toggle';
import './libs/counts';
import './libs/slider';
import './libs/faq';
import './libs/posts';
$(document).ready(() => {
  console.log('Hello word!');
});
AOS.init();

// Your scripts here
// Your scripts here
$('#header .header').each((i, e) => {
  new Header(e, $(e));
});

const $headerE = $('#header');
const $headerP = $('.header');
const $headerT = $('.topheader');
const $btt = $('.backtotop');
$(window).on('scroll', () => {
  let scroll = window.scrollY;
  if (scroll > $headerP.height()) {
    scroll = $headerP.height();
    $headerE.addClass('header__sticky_head');
    $btt.addClass('header__sticky_head');
    $headerT.addClass('topheader__sticky_tophead');
  } else {
    $headerE.removeClass('header__sticky_head');
    $btt.removeClass('header__sticky_head');
    $headerT.removeClass('topheader__sticky_tophead');
  }
  // $headerE.css('margin-top', scroll * -1 + 'px');
});
$(window).trigger('scroll');

$('.menusub').hover(function(){
  $('.header').toggleClass('subactive');
});

$(".hero__scrolldown").click(function (){
  $('html, body').animate({
    scrollTop: $('#s2').offset().top - 55
}, 500, 'linear');
});